import {
  GoogleLogin,
  TokenResponse,
  googleLogout,
  useGoogleLogin,
} from "@react-oauth/google";
import "./guest-login.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { Container, NavItem } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import {
  IUserDbInfo,
  registerUserInfo,
  userRegistrationSelector,
} from "../../../redux/reducers/user-registration/userRegistrationSlice";
import { toast } from "react-toastify";
import {
  createNewUserSession,
  userSessionStateSelector,
} from "../../../redux/reducers/user-session/userSessionSlice";
import LoadingOverlay from "../../../components/loading/LoadingOverlay";

import headerImg from "../../../assets/media/icons/Trowel-Logo.png";
import googleLogo from "../../../assets/media/icons/Google logo.png";
import facebookLogo from "../../../assets/media/icons/facebook logo.png";
import instagramLogo from "../../../assets/media/icons/instagram logo.png";


const GuestLogin: React.FC = () => {

  let apiUrl = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  // Ensure apiUrl ends with a slash
  if (!apiUrl.endsWith('/')) {
    apiUrl += '/';
  }
  console.log("React api url ", apiUrl); 
  const navigate = useNavigate();

  const selectUserInfo = useAppSelector(userRegistrationSelector);
  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const dispatch = useAppDispatch();

  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const handleUserNameChange = (event: any) => {
    setUserName(event.target.value);
  };
  const handlePasswordChange = (event: any) => {
    setPassword(event.target.value);
  };

  type UserType = Omit<
    TokenResponse,
    "error" | "error_description" | "error_uri"
  >;

  type userProfile = {
    email: string;
    id: string;
    given_name: string;
    name: string;
    picture: string;
    verified_email: boolean;
  };

  const [user, setUser] = useState<UserType | null>(null);
  const [profile, setProfile] = useState<userProfile | null>(null);

  const responseMessage = (response: any) => {
    console.log("Response data : ", response);
  };

  const errorMessage = () => {
    console.log("Error");
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => { 
      
      setUser(codeResponse);
      sessionStorage.setItem("access_token", codeResponse.access_token);
      // Note: firmId will be set in the useEffect after backend API call completes

    },
    onError: (error) => console.log("loging failed : ", error),
  });

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res: any) => {
          console.log("Google authentication response ", res);
          setProfile(res.data);
          let signinRequestUrl: string = `${apiUrl}auth/o2/signin`;
          let userProfile: userProfile = res.data;
          if (userProfile?.verified_email) {
            // Step 1:
            // Send API request to send the email notification
            // param: email, name, id, picture
            axios
              .post(signinRequestUrl, {
                //username: userProfile.name,
                email: userProfile.email,
                token: user.access_token,
                //password: userProfile.id //"str0ngP@ssword",
              })
              .then((response) => {
                console.log(
                  "Response received after sign up request",
                  response
                );

                let { message, userId, accessToken, firmId, state, detail } = response.data;
                
                if( detail){
                  toast.error("Login failed, " + detail);
                  return;
                }

                if(state.toLowerCase() === "verification_pending"){
                  toast.info("Please verify your email address, a verification link has been sent to your registered email.");
                  return;
                }

                sessionStorage.setItem("access_token", accessToken);
                sessionStorage.setItem("user_id", userId);
                
                const userSessionData = {
                  ...selectUserSessionInfo,
                  name: userProfile.name,
                  email: userProfile.email,
                  id: userId,
                  profileImage: userProfile.picture,
                  accessToken: accessToken,
                  firmId: firmId,
                };
                
                // Store complete user session info
                sessionStorage.setItem("auth_info", JSON.stringify({
                  accessToken,
                  userId,
                  firmId,
                  state,
                  name: userProfile.name,
                  email: userProfile.email,
                  profileImage: userProfile.picture,
                }));
                
                //Step 2:
                // Dispatch the state to redux store
                dispatch(createNewUserSession(userSessionData));


                //Step 3:
                // After get response from the api call redirect to company-onboard or dashboard based on the current status of the registered user

                // Need to call another api to get the status of the user
                let userStatusUrl = `${apiUrl}auth/user/status/${userId}`;
                axios
                  .get(userStatusUrl, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                  })
                  .then((res: any) => {
                    console.log("Response", res);
                    let userInfo = res.data.userInfo;
                    // let userInitialQuestionnaireCompleted =
                    //   userInfo.state == "REGISTRATION_COMPLETED";
                    // if (userInitialQuestionnaireCompleted) {
                    //   navigate("/company-onboard");
                    // } else {
                    //   navigate("/dashboard");
                    // }

                    if(userInfo.state === "REGISTRATION_COMPLETED"){
                      navigate("/company-onboard");
                    }else if(userInfo.state === "ONBOARDING_QUESTIONS_FILLED"){
                      navigate("/dashboard");
                    }else{
                      toast.error("Something went wrong, please try again later.");
                    }
            
                  })
                  .catch((ex: any) => {
                    console.log("Error fetching", ex);
                  });
              })
              .catch((err: any) => {
                console.log("Error while accessing sign up api", err);

                let { detail } = err.response.data;
                toast.error("Login failed, " + detail);
              });
          }

          /*email: "trowelagent@gmail.com"
family_name: "ai"
given_name: "Trowel"
id: "101750992935389276550"
name: "Trowel ai"
picture: "https://lh3.googleusercontent.com/a/ACg8ocK0WGiMTnX-TV3Fu5r6VIo-erHptBFlhvlVH7vXNpxKQMco6w=s96-c"
verified_email: true */
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  type UserLoginInfo = {
    accessToken: string;
    firmId: string;
    message: string;
    userId: string;
    state: string;
  };

  const trowelLogin = () => {

    // Add validation to check user has enter email and password
    let missingFields: string[] = [];
    if(!userName) missingFields.push("Email");
    if(!password) missingFields.push("Password")
      
    if (missingFields.length > 0) {
      toast.error(`${missingFields.join(", ")} ${missingFields.length === 1 ? "is" : "are"} required`);
      return;
    }

    console.log(userName, password);
    let signinRequestUrl: string = `${apiUrl}auth/signin`;
      //"https://trowelwa01.azurewebsites.net/auth/signin";
    axios
      .post(signinRequestUrl, { email: userName, password: password })
      .then((response: any) => {
        console.log("Response ", response);

        let authorizedUserInfo: UserLoginInfo = { ...response.data };

        sessionStorage.setItem("access_token", authorizedUserInfo.accessToken);
        sessionStorage.setItem("user_id", authorizedUserInfo.userId);
        sessionStorage.setItem("auth_info", JSON.stringify(authorizedUserInfo));
        dispatch(
          createNewUserSession({
            ...selectUserSessionInfo,
            accessToken: authorizedUserInfo.accessToken,
            id: authorizedUserInfo.userId,
            firmId: authorizedUserInfo.firmId,
            name: userName,
            email: userName,
          })
        );
        
        if(authorizedUserInfo.state == "REGISTRATION_COMPLETED"){
          navigate("/company-onboard");
        }else if(authorizedUserInfo.state == "ONBOARDING_QUESTIONS_FILLED"){
          navigate("/dashboard");
        }else{
          toast.error("Something went wrong, please try again later.");
        }
        
      })
      .catch((err: any) => {
        console.log("Error while login ", err);
        if(err?.code == "ERR_NETWORK"){
          toast.error("Error while accessing the login api, please try again later.");
          return;
        }
        let {data} = err?.response;
        if(typeof(data?.detail) == 'string'){
          toast.error(data?.detail);
        }else
        if(data?.detail?.length > 0){
          toast.error(data.detail[0].msg);
        }
      });
  };

  return (
    <div className="login-bg">
      <nav className="navbar navbar-expand-md position-absolute nav-bar-main">
        <div className="container-fluid no-pd-mg">
          <a className="navbar-brand no-pd-mg logo-container" href="/" onClick={()=>navigate('/')}>
            <img src={headerImg} alt="Trowel Logo" className="logo-img" />
          </a>
          <button
            data-bs-toggle="collapse"
            className="navbar-toggler"
            data-bs-target="#navcol-2"
          >
            <span className="visually-hidden">Toggle navigation</span>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navcol-2" style={{ height: 56 }}>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"></li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="container-fluid m-container login-register-container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4 col-xxl-4 justify-content-center" style={{ marginTop: 100 }}>
            <div className="w-100 justify-content-center login-card ">
              <div className="justify-content-center row">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <h3 className="text-center">Login to Trowel</h3>
                  <p className="text-center text-muted mb-4">Access your account</p>
                  <button className="btn w-100 btn-social" onClick={() => googleLogin()}>
                    <img className="img-fluid" width={24} height={25} src={googleLogo} alt="Google" />
                    Google
                  </button>
                  <button className="btn w-100 btn-social">
                    <img className="img-fluid" width={25} height={25} src={facebookLogo} alt="Facebook" />
                    Facebook
                  </button>
                  <button className="btn w-100 btn-social">
                    <img className="img-fluid" width={25} height={25} src={instagramLogo} alt="Instagram" />
                    Instagram
                  </button>
                  <div className="text-center my-3">
                    <span className="text-reset" style={{ color: "#656565" }}>OR</span>
                  </div>
                  <form onSubmit={e => { e.preventDefault(); trowelLogin(); }}>
                    <input
                      className="mb-3 form-control login-input"
                      type="text"
                      placeholder="Email"
                      value={userName}
                      onChange={handleUserNameChange}
                    />
                    <input
                      className="mb-3 form-control login-input"
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <button className="btn btn-lg w-100 btn-main" type="submit">
                      Login
                    </button>
                  </form>
                  <div className="text-center mt-3">
                    <small>
                      <span className="fw-bold text-decoration-none fr-link" style={{ cursor: "pointer" }}>
                        Forgot Password
                      </span>
                    </small>
                  </div>
                  <div className="text-center mt-3">
                    <small>
                      Don't have an account?{" "}
                      <span
                        className="fw-bold text-decoration-none login-link"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/create-account")}
                      >
                        Register
                      </span>
                    </small>
                  </div>
                  <div className="text-center mt-3">
                    <small className="text-muted pr-ag">
                      By continuing, you agree to App’s<br />
                      <span className="text-decoration-none text-info other-link" style={{ cursor: "pointer" }}>
                        User Agreement
                      </span> &amp;{" "}
                      <span className="text-decoration-none text-info other-link" style={{ cursor: "pointer" }}>
                        Privacy Policy
                      </span>.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-bg circle1"></div>
      <div className="banner-container">
        <div className="gr-overlay radial-gradient-position"></div>
        <div className="gr-overlay radial-gradient-position3"></div>
        <div className="gr-overlay radial-gradient-position2"></div>
      </div>
    </div>
  );
};

export default GuestLogin;
